import { render, staticRenderFns } from "./MenuFood.vue?vue&type=template&id=182db062"
import script from "./MenuFood.vue?vue&type=script&lang=js"
export * from "./MenuFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports